//@ts-check
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'

export const useProductComboSegments = () => {
  const {
    productCombo: {allCustomers, excludeSegment, segmentConfiguration},
    setProductCombo,
  } = useProductCombo()
  const includedSegmentGroup = segmentConfiguration?.includedSegments?.[0] ?? null

  const updateSegmentConfiguration = newSegmentConfiguration => {
    setProductCombo(prev => ({
      ...prev,
      comboSkus: [],
      displayCategories: [],
      displayCategoryIds: [],
      segmentConfiguration: {
        ...prev.segmentConfiguration,
        ...newSegmentConfiguration,
      },
    }))
  }

  const handleSubmitSegments = (selectedSegments, _groupIndex, type) => {
    if (isExcludeEnabled) {
      updateSegmentConfiguration({
        excludedSegment: {
          selectionType: type,
          segments: selectedSegments,
        },
      })
    } else {
      updateSegmentConfiguration({
        includedSegments: [
          {
            selectionType: type,
            segments: selectedSegments,
          },
        ],
      })
    }
  }

  /** @param {string} segmentId */
  const handleRemove = segmentId => {
    if (isExcludeEnabled) {
      const updatedExcludedSegments = segmentConfiguration?.excludedSegment?.segments?.filter(
        segment => segment.segmentId !== segmentId
      )
      updateSegmentConfiguration({
        excludedSegment: {
          ...(segmentConfiguration?.excludedSegment ?? {}),
          segments: updatedExcludedSegments,
        },
      })
    } else {
      const updatedIncludedSegments = includedSegmentGroup?.segments?.filter(segment => segment.segmentId !== segmentId)
      updateSegmentConfiguration({
        includedSegments: includedSegmentGroup
          ? [
              {
                ...includedSegmentGroup,
                segments: updatedIncludedSegments,
              },
            ]
          : null,
      })
    }
  }

  /** @param {boolean} newValue */
  const handleAllCustomersToggle = newValue => {
    setProductCombo(prev => ({
      ...prev,
      comboSkus: [],
      allCustomers: newValue,
      ...(newValue === false ? {excludeSegment: false} : {}),
      segmentConfiguration: {
        ...prev.segmentConfiguration,
        includedSegments: null,
        ...(newValue === false ? {excludedSegment: null} : {}),
      },
    }))
  }

  /** @param {boolean} newValue */
  const handleExcludeToggle = newValue => {
    setProductCombo(prev => ({
      ...prev,
      comboSkus: [],
      excludeSegment: newValue,
      segmentConfiguration: {
        ...prev.segmentConfiguration,
        excludedSegment: null,
      },
    }))
  }

  const isAllCustomers = allCustomers
  const isExcludeEnabled = excludeSegment

  return {
    handleAllCustomersToggle,
    handleExcludeToggle,
    isAllCustomers,
    isExcludeEnabled,
    segmentConfiguration,
    handleSubmitSegments,
    handleRemove,
  }
}
